import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useMemo } from 'react';
import { type AdvisoryNeedDto, getAdvisoryNeedsForTalkingPoint } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export function useAdvisoryNeedsForTalkingPoint(talkingPointId?: number): UseQueryResult<AdvisoryNeedDto[], AxiosError> {
    const queryKey = useMemo(() => queryKeys.advisoryNeedsForTalkingPoint(talkingPointId), [talkingPointId]);

    return useQuery({
        queryKey,
        queryFn: ({ signal }) => getAdvisoryNeedsForTalkingPoint({ path: { talkingPointId: talkingPointId! }, signal }).then((res) => res.data),
        enabled: !!talkingPointId,
    });
}
